export const baseClass = 'tamr-progress-bar';
export const variants = ['light', 'dark'];
